const LEGACY_ROUTE_PREFIX = "/v1";

export const LegacyRouteFragment = {
    CONFIGURATIONS: "Configurations",
} as const;

export const LegacyRoute = {
    CLASSIFICATION_CREATE: `${LEGACY_ROUTE_PREFIX}/Classification/Create`,
    CLASSIFICATION_EDIT: `${LEGACY_ROUTE_PREFIX}/Classification/Edit`,
    CONTROL_PREVIEW: `${LEGACY_ROUTE_PREFIX}/Control/PreviewControlResult`,
    CONTROL_PROGRAM: `${LEGACY_ROUTE_PREFIX}/ControlProgram/View`,
    CONTROL_RESULT: `${LEGACY_ROUTE_PREFIX}/Collect/Internal/View`,
    CONTROL_RESULT_COLLECT: `${LEGACY_ROUTE_PREFIX}/Collect/Internal`,
    CONTROL_RESULT_REVIEW: `${LEGACY_ROUTE_PREFIX}/Review/Internal`,
    DASHBOARD_NO_REDIRECT: `${LEGACY_ROUTE_PREFIX}/Dashboard/?noRedirect`,
    REPORT_CONTROL_RESULT_STATUS: `${LEGACY_ROUTE_PREFIX}/Report/ControlResultStatus`,
    REPORT_CONTROL_RESULT_STATUS_SAVED: `${LEGACY_ROUTE_PREFIX}/Report/ControlResultStatus/Saved`,
    REPORT_DATA_SHEET: `${LEGACY_ROUTE_PREFIX}/Report/DataSheet`,
    SHARE: `${LEGACY_ROUTE_PREFIX}/Share`,
    USER_BULK: `${LEGACY_ROUTE_PREFIX}/User/Users/Bulk`,
} as const;

/** A legacy destination leaves the SPA, so it can never be a router link. */
export function isLegacyPath(path: string): boolean {
    return path.startsWith(`${LEGACY_ROUTE_PREFIX}/`);
}
